import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { cn } from '@/lib/utils'
import { getHubName, getHubTheme } from '@/constants/hubs'

interface HubBadgeProps {
    hub: string
    asLink?: boolean
    withIcon?: boolean
    className?: string
}

export const HubBadge: FC<HubBadgeProps> = ({
    hub,
    asLink = true,
    withIcon = true,
    className
}): ReactNode => {
    const theme = getHubTheme(hub)
    const Icon = theme.icon
    const name = getHubName(hub)

    const content = (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold',
                theme.softBg,
                theme.ink,
                className
            )}
        >
            {withIcon && <Icon className='size-3.5' />}
            {name}
        </span>
    )

    if (!asLink) return content

    return (
        <Link href={`/${hub}`} className='relative z-10 inline-flex w-fit'>
            {content}
        </Link>
    )
}
